/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import { useEffect, useState } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
import { useHistory } from "react-router-dom";
import { getImageSmallUrl } from "../../helper/getImageUrl";
import { useUserOrganisationLogo } from "../../hooks/useOrganisation";
 
// reactstrap components
import {
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";
import { LocalStorageCoBrandingLogo } from "../../helper/constants";
import Loading from "../Loading";

const Sidebar = (props) => {
  const history = useHistory();
  const [collapseOpen, setCollapseOpen] = useState();
  const [tempLogo, setTempLogo] = useState();
  
  // toggles collapse between opened and closed (true/false)
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };
  // closes the collapse
  const closeCollapse = () => {
    setCollapseOpen(false);
  };
  // creates the links that appear in the left menu / Sidebar
  const createLinks = (routes) => {
    return routes
      .filter((x) => x.showInSidebar)
      .map((route, key) => {
        return (
          <NavItem key={key}>
            <NavLink
              to={route.path}
              tag={NavLinkRRD}
              onClick={closeCollapse}
              activeClassName="active"
              className="text-lowercase"
            >
              <i className={route.icon} />
              {/* All link in the dashboard should be in lowercase */}
              {route.name}
            </NavLink>
          </NavItem>
        );
      });
  };

  const { routes, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }

  const [organisation, setOrganisation] = useState(null);
  const { data, loading } = useUserOrganisationLogo(); 

  useEffect(() => {
    if(data) {
      const orgData = data.me.organisation;
      setOrganisation(orgData);
      setTempLogo(orgData.image_id)

      window.localStorage.setItem(LocalStorageCoBrandingLogo, orgData.image_id || "");
    }
  },[data]);

  useEffect(() => {
    const getLogo = window.localStorage.getItem(LocalStorageCoBrandingLogo);
    if(getLogo){
      setTempLogo(getLogo);
    }
  })

  return (
    <Navbar
      className="navbar-vertical fixed-left navbar-light bg-white "
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        {/* Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-icon" />
        </button>
        {/* Brand */}
        {logo ? (
          <NavbarBrand className="pt-0 pb-0" {...navbarBrandProps}>
            <img
              alt={logo.imgAlt}
              src={logo.imgSrc}
              className="navbar-brand-img"
            />
          </NavbarBrand>
        ) : null}
        {/* User */}
        <Nav className="align-items-center d-md-none">
          <UncontrolledDropdown nav>
            <DropdownToggle nav>
              <Media className="align-items-center">
                <span>
                  <i className="ni ni-single-02"></i>
                  <i className="ml-2 ni ni-bold-down"></i>
                </span>
              </Media>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-arrow" right>
              {/* <DropdownItem onClick={() => history.push("/user/settings")}>
                <i className="ni ni-settings-gear-65" />
                <span>Settings</span>
              </DropdownItem> */}
              <DropdownItem href="#pablo" onClick={(e) => e.preventDefault()}>
                <i className="ni ni-user-run" />
                <span>Logout</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
        {/* Collapse */}
        <Collapse navbar isOpen={collapseOpen}>
          {/* Collapse header */}
          <div className="navbar-collapse-header d-md-none">
            <Row>
              {logo ? (
                <Col className="collapse-brand" xs="6">
                  {logo.innerLink ? (
                    <Link to={logo.innerLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </Link>
                  ) : (
                    <a href={logo.outterLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </a>
                  )}
                </Col>
              ) : null}
              <Col className="collapse-close" xs="6">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleCollapse}
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>
          {/* Navigation */}
          <Nav navbar
          vertical
          >
            {createLinks(routes)}
            {/* Reset Dashboard Link */}
            <NavItem role="button">
              <NavLink
                href="https://www.winihealth.com"
                target="_blank"
                referrerPolicy="no-referrer"
              >
                <i className="text-primary far fa-star" />
                Wini 
              </NavLink>
            </NavItem>
            {/* Onboarding checklist */}
            <NavItem role="button">
              <NavLink onClick={() => props.openChecklist()}>
                <i className="text-primary ni ni-check-bold" />
                onboarding checklist
              </NavLink>
            </NavItem>

          </Nav>
          {/* {
            !organisation && tempLogo &&
            <a className="mt-auto d-flex justify-content-center">
              <img
                
                alt="co-branding.png"
                src={getImageSmallUrl(tempLogo)}
                style={{
                  height : "40px",
                  width : "100%",
                  objectFit :"contain",
                }}
              />
            </a>
          } */}
          {
            organisation && organisation.image_id && 
            <a className="mt-auto d-flex justify-content-center" target={organisation.eap_link ? "_blank" : ""}
            href={organisation.eap_link  || "#"}>
              <img
                
                alt={organisation.name}
                src={getImageSmallUrl(organisation.image_id)}
                style={{
                  height : organisation.image_width || "40px",
                  width : "100%",
                  objectFit :"contain",
                }}
              />
            </a>
          }
        </Collapse>
      </Container>
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
